angular.module('tf.controllers')

    .controller('AppLoginController', ['$scope', '$rootScope', 'AuthService','Session','$state','$timeout', '$stateParams','AuthAlertService','$cookies','NotificationService',
            function ($scope, $rootScope, AuthService,Session, $state, $timeout, $stateParams, AuthAlertService, $cookies, NotificationService) {

                $scope.disableButton = false;
                $scope.isLoggedIn = AuthService.isAuthenticated;
                $scope.credentials = {
                    email: '',
                    password: '',
                    failState: 'app-login'
                };
                $scope.login = function (credentials) {

                    AuthService.login(credentials);
                };
                $scope.signup = function (credentials) {
                    AuthService.signup(credentials);
                };
                $scope.resetEmail = function(credentials){
                    $scope.disableButton = true;
                    AuthService.resetEmail(credentials).then(function(){

                        NotificationService.notify('info-alert', {content: "notifications.resetPasswordEmailSuccess"});
                    }, function(){
                        $scope.disableButton = false;
                    });
                };
                $scope.reset = function(credentials){
                    if(credentials.password !== credentials.confirmPassword){
                        return AuthAlertService.alert('Passwords must match', 'danger');
                    }
                    $scope.disableButton = true;
                    AuthService.resetPassword(credentials);
                };

                var email = Session.getEmail();
                if(email){
                    $scope.credentials.email = email;
                    $scope.credentials.confirmEmail = email;
                    $scope.emailPreset = true;
                }
                $scope.$on("login-info", function(event, data){
                    $scope.showAlert(data);
                });
                $scope.$on("login-error", function(event, data){
                    $scope.showAlert(data);
                });
                $scope.$on("signup-error", function(event, data){
                    $scope.showAlert(data);
                });
                $scope.showAlert = function(alert){
                    $timeout(function(){alert.show();},1);
                };

                if($stateParams.error){
                    //AuthAlertService.loginError($stateParams.error[0]);
                }

                $scope.resendVerificationEmail = function(){
                    var email = $cookies.get('user_email');
                    if(email){
                        AuthService.resendVerificationEmail(email).then(function () {
                            NotificationService.notify('info-alert', {content: "Please check your email to verify your account"});
                        });
                    }
                };


    }])
;
